//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets a calendar configuration by id.
 * @param id Id of calendar configuration.
 */
export function getCalendarConfiguration(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.CalendarConfigurationDto> {
    let url_ = getBaseUrl() + "/api/calendar-configuration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCalendarConfiguration,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCalendarConfiguration?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCalendarConfiguration(_response);
    });
}

function processGetCalendarConfiguration(response: AxiosResponse): Promise<Types.CalendarConfigurationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCalendarConfigurationDto(resultData200);
        return Promise.resolve<Types.CalendarConfigurationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CalendarConfigurationDto>(null as any);
}

export function editCalendarConfiguration(id: number, updateDto: Types.UpdateCalendarConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<Types.CalendarConfigurationDto> {
    let url_ = getBaseUrl() + "/api/calendar-configuration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateCalendarConfigurationDto(updateDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditCalendarConfiguration,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigEditCalendarConfiguration?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditCalendarConfiguration(_response);
    });
}

function processEditCalendarConfiguration(response: AxiosResponse): Promise<Types.CalendarConfigurationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCalendarConfigurationDto(resultData200);
        return Promise.resolve<Types.CalendarConfigurationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CalendarConfigurationDto>(null as any);
}

export function removeCalendarConfiguration(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/calendar-configuration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveCalendarConfiguration,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveCalendarConfiguration?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveCalendarConfiguration(_response);
    });
}

function processRemoveCalendarConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function getCalendarConfigurations(config?: AxiosRequestConfig | undefined): Promise<Types.CalendarConfigurationListDto[]> {
    let url_ = getBaseUrl() + "/api/calendar-configuration";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCalendarConfigurations,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCalendarConfigurations?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCalendarConfigurations(_response);
    });
}

function processGetCalendarConfigurations(response: AxiosResponse): Promise<Types.CalendarConfigurationListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initCalendarConfigurationListDto(item)
              );
            }
        return Promise.resolve<Types.CalendarConfigurationListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CalendarConfigurationListDto[]>(null as any);
}

export function createCalendarConfiguration(createDto: Types.CreateCalendarConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<Types.CalendarConfigurationDto> {
    let url_ = getBaseUrl() + "/api/calendar-configuration";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateCalendarConfigurationDto(createDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateCalendarConfiguration,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateCalendarConfiguration?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateCalendarConfiguration(_response);
    });
}

function processCreateCalendarConfiguration(response: AxiosResponse): Promise<Types.CalendarConfigurationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCalendarConfigurationDto(resultData200);
        return Promise.resolve<Types.CalendarConfigurationDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initCalendarConfigurationDto(resultData201);
        return Promise.resolve<Types.CalendarConfigurationDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CalendarConfigurationDto>(null as any);
}

export function pinCalendarConfiguration(id: number, dto: Types.PinCalendarConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/calendar-configuration/pin/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePinCalendarConfigurationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPinCalendarConfiguration,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPinCalendarConfiguration?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPinCalendarConfiguration(_response);
    });
}

function processPinCalendarConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetCalendarConfiguration: Partial<AxiosRequestConfig> | null;
export function getGetCalendarConfigurationRequestConfig() {
  return _requestConfigGetCalendarConfiguration;
}
export function setGetCalendarConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCalendarConfiguration = value;
}
export function patchGetCalendarConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCalendarConfiguration = patch(_requestConfigGetCalendarConfiguration ?? {});
}

let _requestConfigEditCalendarConfiguration: Partial<AxiosRequestConfig> | null;
export function getEditCalendarConfigurationRequestConfig() {
  return _requestConfigEditCalendarConfiguration;
}
export function setEditCalendarConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditCalendarConfiguration = value;
}
export function patchEditCalendarConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditCalendarConfiguration = patch(_requestConfigEditCalendarConfiguration ?? {});
}

let _requestConfigRemoveCalendarConfiguration: Partial<AxiosRequestConfig> | null;
export function getRemoveCalendarConfigurationRequestConfig() {
  return _requestConfigRemoveCalendarConfiguration;
}
export function setRemoveCalendarConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveCalendarConfiguration = value;
}
export function patchRemoveCalendarConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveCalendarConfiguration = patch(_requestConfigRemoveCalendarConfiguration ?? {});
}

let _requestConfigGetCalendarConfigurations: Partial<AxiosRequestConfig> | null;
export function getGetCalendarConfigurationsRequestConfig() {
  return _requestConfigGetCalendarConfigurations;
}
export function setGetCalendarConfigurationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCalendarConfigurations = value;
}
export function patchGetCalendarConfigurationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCalendarConfigurations = patch(_requestConfigGetCalendarConfigurations ?? {});
}

let _requestConfigCreateCalendarConfiguration: Partial<AxiosRequestConfig> | null;
export function getCreateCalendarConfigurationRequestConfig() {
  return _requestConfigCreateCalendarConfiguration;
}
export function setCreateCalendarConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateCalendarConfiguration = value;
}
export function patchCreateCalendarConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateCalendarConfiguration = patch(_requestConfigCreateCalendarConfiguration ?? {});
}

let _requestConfigPinCalendarConfiguration: Partial<AxiosRequestConfig> | null;
export function getPinCalendarConfigurationRequestConfig() {
  return _requestConfigPinCalendarConfiguration;
}
export function setPinCalendarConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPinCalendarConfiguration = value;
}
export function patchPinCalendarConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPinCalendarConfiguration = patch(_requestConfigPinCalendarConfiguration ?? {});
}